// Basissicherheit Lernpfad - 10 Module
// Diese Module sind aktuell die einzigen freigeschalteten Module
export const BASISSICHERHEIT_MODULE_IDS = [1, 2, 3, 4, 7, 11, 13, 15, 16, 18];

// Checklist data structure - nur Basissicherheit Module
export const CHECKLIST_DATA = [
  {
    category: 'Basissicherheit',
    items: [
      {
        id: 1,
        title: 'Sichere Passwörter erstellen',
        description: 'Erstellen Sie Passwörter mit mindestens 16 Zeichen, die Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten. Vermeiden Sie persönliche Informationen.',
        priority: 'Unverzichtbar',
        completed: false,
        video: null,
        moduleName: 'Sichere Passwörter'
      },
      {
        id: 2,
        title: 'Multi-Faktor-Authentifizierung (MFA) aktivieren',
        description: 'Aktivieren Sie 2FA/MFA für alle wichtigen Konten (E-Mail, Banking, Social Media) mit einer Authenticator-App wie Authy oder Google Authenticator.',
        priority: 'Unverzichtbar',
        completed: false,
        video: null,
        moduleName: 'MFA'
      },
      {
        id: 3,
        title: 'Passwort-Manager verwenden',
        description: 'Nutzen Sie einen Passwort-Manager wie Bitwarden, 1Password oder KeePass, um sichere, einzigartige Passwörter für alle Ihre Konten zu erstellen und zu speichern.',
        priority: 'Unverzichtbar',
        completed: false,
        video: null,
        moduleName: 'Passwort-Manager'
      },
      {
        id: 18,
        title: 'Backups erstellen',
        description: 'Erstellen Sie regelmäßige Backups Ihrer wichtigen Daten auf externe Festplatten oder Cloud-Speicher.',
        priority: 'Unverzichtbar',
        completed: false,
        video: null,
        moduleName: 'Backups'
      },
      {
        id: 16,
        title: 'Automatische Updates aktivieren',
        description: 'Aktivieren Sie automatische Updates für Ihr Betriebssystem und alle Apps, um Sicherheitslücken zu schließen.',
        priority: 'Unverzichtbar',
        completed: false,
        video: null,
        moduleName: 'Automatische Updates'
      },
      {
        id: 7,
        title: 'E-Mail-Konto absichern',
        description: 'Aktivieren Sie 2FA für Ihr E-Mail-Konto, da es der Schlüssel zu allen anderen Konten ist. Verwenden Sie ein starkes, einzigartiges Passwort.',
        priority: 'Unverzichtbar',
        completed: false,
        video: null,
        moduleName: 'Email Account absichern'
      },
      {
        id: 4,
        title: 'Ad-Blocker installieren',
        description: 'Installieren Sie einen Ad-Blocker wie uBlock Origin, um Tracking und schädliche Werbung zu blockieren.',
        priority: 'Unverzichtbar',
        completed: false,
        video: null,
        moduleName: 'Ad-Blocker'
      },
      {
        id: 13,
        title: 'Router-Passwort ändern',
        description: 'Ändern Sie das Standard-Passwort Ihres Routers und verwenden Sie WPA3-Verschlüsselung, wenn verfügbar.',
        priority: 'Unverzichtbar',
        completed: false,
        video: null,
        moduleName: 'Router Passwort ändern'
      },
      {
        id: 11,
        title: 'Social Media Privatsphäre-Einstellungen überprüfen',
        description: 'Überprüfen und verschärfen Sie die Privatsphäre-Einstellungen auf allen Social-Media-Plattformen. Teilen Sie so wenig persönliche Informationen wie möglich.',
        priority: 'Unverzichtbar',
        completed: false,
        video: null,
        moduleName: 'Social Media'
      },
      {
        id: 15,
        title: 'App-Berechtigungen überprüfen',
        description: 'Überprüfen Sie regelmäßig die App-Berechtigungen auf Ihrem Smartphone und gewähren Sie nur die notwendigen Berechtigungen.',
        priority: 'Unverzichtbar',
        completed: false,
        video: null,
        moduleName: 'App-Berechtigungen'
      }
    ]
  },
];


